import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  json : "",
  lat:'',
  lng:'',
  show:'',
};

const cqlDataSlice = createSlice({
  name: "cqldata",
  initialState,
  reducers: {
    setcqlData: (state, action) => {
      state.json = action.payload.json;
      state.lat = action.payload.lat;
      state.lng = action.payload.lng;
      state.show = action.payload.show;
    },
  },
});

export const { setcqlData } = cqlDataSlice.actions;
export const selectcqlData = (state) => state.cqldata;

export default cqlDataSlice.reducer;